<div class="price" [class.top-right]="position==='top-right'">
  <span class="default-total" [class.discount-available]="totalAmount!==totalAmountDiscounted">{{ totalAmount | currency:currencyObserver.currentCurrency }}</span>
  <span class="discounted-total"
        *ngIf="totalAmount!==totalAmountDiscounted">{{ totalAmountDiscounted | currency:currencyObserver.currentCurrency }}</span>
</div>
